import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=d4188b90&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=ts"
export * from "./FooterBar.vue?vue&type=script&lang=ts"
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=d4188b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4188b90",
  null
  
)

export default component.exports